//     const response = await axiosInstance.pose('report/getReport', couchId);
//     return response.data;

// }catch(error){
//      console.error('Error fetching Students data:', error);
//     throw error;
// }
// }
import toast from 'react-hot-toast';
import axiosInstance from 'services/axiosMiddleware';

export async function getReport(userID) {
  try {
    const response = await axiosInstance.post('report/getReport', userID);

    return response.data;
  } catch (error) {
    console.error('Error fetching report data:', error);
    throw error;
  }
}
